module.exports = __webpack_public_path__ + "static/media/undraw_empty_cart_co35.29d37f44.svg";